import { useMemo } from 'react';
import {
  Box,
  Center,
  Column,
  ConfirmPopup,
  Divider,
  Pressable,
  Row,
  Text,
} from '~/commonComponents';
import { useToggle } from '~/hooks';
import { useUserSelector } from '~/hooks/useUserSelector';
import BestInDentalBadge from '~/images/best-in-dental.png';
import LogoDarkFull from '~/images/logos/logoDarkFull.svg';
import { Colors } from '~/themes/colors';

export const BestInDentalWinner = () => {
  const currentUser = useUserSelector();
  const [isOpen, controls] = useToggle();

  const isWinning = useMemo(() => {
    return currentUser?.office_info?.bestInDental?.status === 'winner';
  }, [currentUser]);

  const winningYear = useMemo(() => {
    if (!isWinning) {
      return null;
    }

    const bestInDental = currentUser?.office_info?.bestInDental;

    if (bestInDental?.winnerDetails?.length === 0) {
      return null;
    }

    return currentUser?.office_info?.bestInDental?.winnerDetails?.[0]?.winningYear;
  }, [currentUser, isWinning]);

  if (!isWinning) {
    return null;
  }

  return (
    <>
      <Divider width={1 as any} height={'50%' as any} />
      <Pressable onPress={() => controls.setOn()}>
        <Row
          width={214}
          height={104}
          borderRadius={14}
          backgroundColor="#F4FCFF"
          boxShadow="0px 1px 2px 0px rgba(0, 0, 0, 0.15), 0px 1px 3px 1px rgba(0, 0, 0, 0.15)"
          alignItems="center"
          justifyContent="center"
          gap={4}
        >
          <Center width={92} height={82}>
            <img
              alt="Best In Dental Badge"
              src={BestInDentalBadge}
              style={{ width: '100%', height: '100%', objectFit: 'contain' }}
            />
          </Center>
          <Column>
            <Box width={62} height={30} marginBottom={8}>
              <img
                alt="GoTu Logo"
                src={LogoDarkFull}
                style={{ width: '100%', height: '100%', objectFit: 'contain' }}
              />
            </Box>
            <Text
              fontSize={24}
              fontWeight={800}
              color={Colors.best_in_dental_year}
              lineHeight="24px"
            >
              {winningYear}
            </Text>
            <Text
              fontSize={24}
              fontWeight={800}
              color={Colors.best_in_dental_winning}
              lineHeight="24px"
            >
              Winner
            </Text>
          </Column>
        </Row>
      </Pressable>
      {isOpen && (
        // @ts-expect-error - ConfirmPopup still written in JavaScript
        <ConfirmPopup
          modalStyle={{ maxWidth: 500, maxHeight: 520, paddingTop: 57 }}
          Icon={() => (
            <img alt="Best In Dental Badge" src={BestInDentalBadge} width={150} height={170} />
          )}
          title="This Office is one of GoTu’s Best In Dental"
          titleStyle={{ marginBlock: 16 }}
          description={
            <Column>
              <Text color={Colors.neutral_500}>
                You’ve been recognized for consistently providing a standout
              </Text>
              <Text color={Colors.neutral_500}>
                experience to GoTu professionals, from smooth workflows to
              </Text>
              <Text color={Colors.neutral_500}>
                great communication. The feedback from pros speaks for
              </Text>
              <Text color={Colors.neutral_500}>itself, and they keep coming back.</Text>
              <Text color={Colors.neutral_500} marginTop={16}>
                Your reputation is well-earned
              </Text>
            </Column>
          }
          descriptionStyle={{ marginBottom: 32, width: '100%' }}
          rightButtonText="Got it!"
          rightButtonAction={controls.setOff}
        />
      )}
    </>
  );
};
